module.exports = __webpack_public_path__ + "static/media/feature2.48e565f6.jpg";